module.exports = __webpack_public_path__ + "61980640f37bfd234488408323ab8123.pdf";